import { render } from "./MdClearIcon.vue?vue&type=template&id=ad435e1e"
import script from "./MdClearIcon.vue?vue&type=script&lang=js"
export * from "./MdClearIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__